import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import OktaSignIn from '@okta/okta-signin-widget'
import '@okta/okta-signin-widget/css/okta-sign-in.min.css'
import logo from '../../assets/marley.png'

export default class OktaSignInWidget extends Component {
  componentDidMount() {
    const el = ReactDOM.findDOMNode(this)
    const cfg = this.props.config
    this.widget = new OktaSignIn({
      baseUrl: cfg.baseUrl,
      issuer: cfg.issuer,
      clientId: cfg.clientId,
      redirectUri: cfg.redirectUri,
      scopes: cfg.scopes,
      useClassicEngine: cfg.useClassicEngine !== false,
      authParams: {
        issuer: cfg.authParams?.issuer || cfg.issuer,
        pkce: cfg.authParams?.pkce !== false,
      },
      logo,
      features: {
        idpDiscovery: true,
        rememberMe: true,
      },
      idpDiscovery: {
        requestContext: window.location.href,
      },
      colors: {
        brand: '#F9685D'
      },
      language: 'en',
      i18n: {
        'en': {
          'primaryauth.title': process.env.ENVIRONMENT_PRETTY_NAME || ' ',
          'primaryauth.submit': 'Sign In',
          // More e.g. [primaryauth.username.placeholder,  primaryauth.password.placeholder, needhelp, etc.].
          // Full list here: https://github.com/okta/okta-signin-widget/blob/master/packages/@okta/i18n/dist/properties/login.properties
        }
      },
    })
    this.widget.renderEl({el}, this.props.onSuccess, this.props.onError)
  }

  componentWillUnmount() {
    this.widget.remove()
  }

  render() {
    return <div className='sign-in-widget'/>
  }
}
